// extracted by mini-css-extract-plugin
module.exports = {"container":"use-device-chart_container_yQsp_","common":"use-device-chart_common_3VWKI","title":"use-device-chart_title_220F3","chartBox":"use-device-chart_chartBox_2AZWj"};